// extracted by css-extract-rspack-plugin
export default {"container":"responsive-composer-module__container__WVjbC","pickers":"responsive-composer-module__pickers__K2kak"};